import { types } from '../../../constants/ActionTypes'

const initialState = {
  anchorEl: null
}

const titleGrid = (state = initialState, action) => {
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      return { ...state, anchorEl: null }
    case types.titleGrid.menu.OPEN:
      return { ...state, anchorEl: action.anchorEl }
    case types.titleGrid.menu.CLOSE:
      return { ...state, anchorEl: null }
    default:
      return state
  }
}

export default titleGrid


// WEBPACK FOOTER //
// ./src/reducers/Common/TitleGrid/TitleGrid.js